import { render, staticRenderFns } from "./mostFollowed.vue?vue&type=template&id=3b5ff8a2&scoped=true&"
import script from "./mostFollowed.vue?vue&type=script&lang=js&"
export * from "./mostFollowed.vue?vue&type=script&lang=js&"
import style0 from "./mostFollowed.vue?vue&type=style&index=0&id=3b5ff8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ff8a2",
  null
  
)

export default component.exports